import { Input } from '@aloft/toolkit-sui';

import { Controller, useFormContext } from 'react-hook-form';

import { Td } from '../table.tsx';
import { FilterRangeWrapperProps } from './types.ts';

export const AreaRangeInputs = ({ minName, maxName }: FilterRangeWrapperProps) => {
  const { control } = useFormContext();
  return (
    <>
      <Td type="editable" backgroundColor="white">
        <Controller
          name={minName}
          control={control}
          render={({ field, fieldState }) => (
            <Input
              id={minName}
              size="sm"
              type="aloftArea"
              unit="sqft"
              placeholderText="No min"
              autoFocus
              border="hidden"
              borderRadius={0}
              boxShadow="none!important"
              isInvalid={fieldState.invalid}
              onClear={() => {
                field.onChange('');
              }}
              {...field}
            />
          )}
        />
      </Td>
      <Td type="editable" backgroundColor="white">
        <Controller
          name={maxName}
          control={control}
          render={({ field, fieldState }) => (
            <Input
              id={maxName}
              size="sm"
              type="aloftArea"
              unit="sqft"
              placeholderText="No max"
              autoFocus
              border="hidden"
              borderRadius={0}
              boxShadow="none!important"
              isInvalid={fieldState.invalid}
              onClear={() => {
                field.onChange('');
              }}
              {...field}
            />
          )}
        />
      </Td>
    </>
  );
};
